import type { RecaptchaWrapper } from '../../../utils/createRecaptchaWrapper';
import OnePageGivingMessaging from '../../OnePageGivingMessaging';
import { ErrorResponse } from '../../types';

const handle = async (response: ErrorResponse, recaptcha: RecaptchaWrapper) => {
  if (response.recaptchaValidated) {
    recaptcha.reset();
  }

  OnePageGivingMessaging.addPageError(response.message);
};

export default {
  handle,
};
